import { ReactNode, createContext, useContext } from 'react';
import { DocumentUploadRequest, DocumentUploadResponse as UploadResponse } from 'vopay';
import type { DocumentUploadResponse } from '../hooks/useApi/usePostDocumentUpload';
import usePostDocumentUpload from '../hooks/useApi/usePostDocumentUpload';

type DocumentCtx = {
  response: DocumentUploadResponse | undefined;
  postDocument: (requestParams: DocumentUploadRequest, bearerToken: string) => void;
  uploadDocument: (requestParams: DocumentUploadRequest, bearerToken: string) => Promise<UploadResponse>;
  reset: () => void;
};

const defaultData = { success: false, errorMessage: '', documentID: '' };

export const DocumentContext = createContext<DocumentCtx>({
  response: defaultData,
  postDocument: () => {},
  uploadDocument: () => new Promise<UploadResponse>(() => {}),
  reset: () => {},
});

export const DocumentProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [response, postDocument, uploadDocument, reset] = usePostDocumentUpload({});

  return (
    <DocumentContext.Provider
      value={{
        response,
        postDocument,
        uploadDocument,
        reset,
      }}
    >
      {children}
    </DocumentContext.Provider>
  );
};

export const useDocument = (): DocumentCtx => useContext(DocumentContext);
